import { useEffect } from 'react';
import { initTracking, type TrackingConfig } from '../lib/tracking';
import { api } from '../lib/api';

let initialized = false;

/**
 * Fetches the public tracking configuration from the backend and initializes
 * all enabled browser-side pixel SDKs.  Call this once at the app root.
 */
export function useTrackingInit(): void {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    api
      .get<TrackingConfig>('/tracking-config')
      .then((res) => {
        initTracking(res.data);
      })
      .catch(() => {
        // Tracking failure must never break the storefront
      });
  }, []);
}
